import React from 'react';

const Anchor = ({ width = '20px', height = '20px', color = '#000000' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 256 256"
    >
      <path d="M216,132a12.0006,12.0006,0,0,0-12,12,36.04061,36.04061,0,0,1-36,36,51.67636,51.67636,0,0,0-28,8.2168V124h28a12,12,0,0,0,0-24H140V81.65674a32,32,0,1,0-24,0V100H88a12,12,0,0,0,0,24h28v64.2168A51.67636,51.67636,0,0,0,88,180a36.04061,36.04061,0,0,1-36-36,12,12,0,0,0-24,0,60.06812,60.06812,0,0,0,60,60,28.03146,28.03146,0,0,1,28,28,12,12,0,0,0,24,0,28.03146,28.03146,0,0,1,28-28,60.06812,60.06812,0,0,0,60-60A12.0006,12.0006,0,0,0,216,132ZM128,44a8,8,0,1,1-8,8A8.00917,8.00917,0,0,1,128,44Z" />
    </svg>
  );
};

export default Anchor;
